export function normalizeShift(rawShift) {
    if (!rawShift) {
        return null
    }

    const result = {
        id: rawShift.id || null,
        cash_desk_id: rawShift.cash_desk_id || null,
        division_id: rawShift.division_id || null,
        cashier_id: rawShift.cashier_id || null,
        rkeeper_shift_id: rawShift.rkeeper_shift_id != null ? String(rawShift.rkeeper_shift_id) : null,
        status: rawShift.status || 'pending',
        opened_at: rawShift.opened_at || null,
        closed_at: rawShift.closed_at != null ? rawShift.closed_at : null,
        shift_number: rawShift.shift_number || null,
        cashier_full_name: rawShift.cashier_full_name || null
    }

    if (!result.id) {
        console.warn('[normalizeShift] shift_id отсутствует:', rawShift)
        return null
    }

    return result
}